import classNames from "classnames";
import style from "./responsive-template-card-new.module.css";
import { TemplateCardStyle } from "frontend/modals/templates/components/legacy/template-card/template-card";
import tracking from "frontend/tracking";
import consts from "shared/consts";
import { getPathPrefix } from "utils/getPathPrefix";

export function ShowAllTemplatesCardNew({
  cardStyle = TemplateCardStyle.regular,
  setShowTemplatesModal,
}: {
  cardStyle?: TemplateCardStyle;
  setShowTemplatesModal: (show: boolean) => void;
}) {
  const isSmall = cardStyle === TemplateCardStyle.small;

  return (
    <>
      <div
        className={classNames(style.gridContainer, { [style.small]: isSmall })}
        onClick={() => {
          tracking.trackAnalyticsEvent("templates-library-clicked", {
            category: consts.TRACKING_CATEGORY.TEMPLATES,
            source: "template-section",
            isNewHomePage: true,
          });
          setShowTemplatesModal(true);
        }}
        data-testid="all-templates-card"
      >
        <div className={classNames(style.templateImage, { [style.small]: isSmall })}>
          <div className={style.allTemplatesIcon}>
            <img src={getPathPrefix("/images/new-homepage/all-templates.svg")} alt={""} />
          </div>
        </div>
        <div className={classNames(style.templateTitle, { [style.small]: isSmall })}>All templates</div>
      </div>
    </>
  );
}
